import classNames from "classnames";
import { useFormik } from "formik";
import { useEffect } from "react";
import CustomTextArea from "shared/components/common/customTextArea";
import { QuestionnaireStep10VS } from "shared/utils/validation";
import styles from "./style.module.scss";

interface formikValuesInterface {
  jobs: QuestionnaireStep10Type[];
}

interface QuestionnaireStep10Props {
  formikRef: any;
  formData: any;
}

const QuestionnaireStep10 = ({
  formikRef,
  formData,
}: QuestionnaireStep10Props) => {
  const initialValues: formikValuesInterface = {
    jobs: [
      {
        jobTitle: "",
        notes: "",
      },
    ],
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: QuestionnaireStep10VS,
    onSubmit: () => {},
  });

  const { values, touched, errors, setFieldValue } = formik;

  useEffect(() => {
    formikRef.current = formik;
    // eslint-disable-next-line
  }, [formik]);

  useEffect(() => {
    let jobs = formData;
    let fields: any = [];
    for (let k = 0; k < jobs?.length; k++) {
      let obj = {
        jobTitle: jobs?.[k]?.jobTitle,
        notes: jobs?.[k]?.q9?.notes,
      };
      fields.push(obj);
    }
    formik.setFieldValue("jobs", fields);
    // eslint-disable-next-line
  }, [formData]);

  return (
    <div className={classNames(styles.stepContainer)}>
      <div className={classNames(styles.head)}>
        <p>Notes / Comments (Optional)</p>
        <h1>
          <span>Q9.</span> Enter any notes or comments for rationale of the
          evaluation.
        </h1>
      </div>
      <div className={classNames(styles.tableWrapper)}>
        <table className="table" style={{ minWidth: "800px", margin: "0px" }}>
          <thead>
            <tr style={{ height: "44px" }}>
              <th className={classNames(styles.tableHead)}>Job Title</th>
              <th className={classNames(styles.tableHead)}>Notes</th>
            </tr>
          </thead>
          <tbody>
            {values.jobs.map((job, index) => {
              return (
                <tr key={index}>
                  <td
                    className={classNames(styles.tableContentLabel)}
                    style={{ width: "15%", wordBreak: "break-all" }}
                  >
                    <div className={classNames(styles.titleContainer)}>
                      <label>{job.jobTitle}</label>
                    </div>
                  </td>
                  <td
                    className={classNames(styles.tableContentLabel)}
                    style={{ width: "85%" }}
                  >
                    <CustomTextArea
                      placeholder="Enter Notes / Comments (Optional)"
                      value={job.notes}
                      error={
                        touched.jobs?.[index]?.notes &&
                        //@ts-ignore
                        errors.jobs?.[index]?.notes
                      }
                      onChange={(e: any) => {
                        if (e.currentTarget.value.length <= 6000) {
                          setFieldValue(
                            "jobs." + index + ".notes",
                            e.currentTarget.value
                          );
                        }
                      }}
                      onPaste={(e: any) => {
                        const pastedData =
                          job.notes + e.clipboardData.getData("Text");
                        const truncatedData = pastedData.slice(0, 6000);
                        e.preventDefault();
                        setFieldValue(
                          "jobs." + index + ".notes",
                          truncatedData
                        );
                      }}
                      limit={6000}
                      showLimit={true}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuestionnaireStep10;
